(() => {
  if (window.baesicVehicleNavigationReady) return;
  window.baesicVehicleNavigationReady = true;
  const desktop = window.matchMedia('(min-width: 700px)');
  const states = new WeakMap();
  const initialize = (root) => {
    root.querySelectorAll('.nav-catalog__description').forEach((details) => {
      if (states.has(details)) return;
      const summary = details.querySelector('summary');
      const state = { interacted: false };
      states.set(details, state);
      details.open = desktop.matches;
      const sync = () => summary.setAttribute('aria-expanded', String(details.open));
      summary.addEventListener('click', () => { state.interacted = true; });
      details.addEventListener('toggle', sync);
      details.dataset.ready = 'true';
      sync();
    });
  };
  desktop.addEventListener('change', () => {
    document.querySelectorAll('.nav-catalog__description').forEach((details) => {
      const state = states.get(details);
      if (state && !state.interacted) {
        details.open = desktop.matches;
        details.querySelector('summary').setAttribute('aria-expanded', String(details.open));
      }
    });
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
